import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group-append" }
const _hoisted_4 = { class: "btn-group justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-filter3" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cross2" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "dropdown-item custom-control custom-switch"
}
const _hoisted_10 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_11 = { class: "dropdown-header text-uppercase font-size-xs line-height-xs" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "custom-control-label" }
const _hoisted_14 = { class: "d-flex flex-row flex-wrap mt-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "font-italic" }
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times-circle ml-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        placeholder: "Suche",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.search) = $event)),
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
      }, null, 544), [
        [_vModelText, _ctx.frm.search]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "",
            class: "btn bg-light dropdown-toggle border-top border-right border-bottom border-radius-0",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
          }, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["dropdown-box", { 'show':_ctx.showDropdown }])
      }, [
        _createElementVNode("button", {
          class: "btn-close btn btn-icon",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"]))
        }, _hoisted_8),
        (!_ctx.frm.filter || _ctx.frm.filter.length <= 0)
          ? (_openBlock(), _createElementBlock("label", _hoisted_9, " Keine Filter vorhanden "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frm.filter, (data, fIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fIndex,
              class: "p-2"
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(data.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.items, (item, index) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: index,
                  class: "dropdown-item custom-control custom-switch custom-control-dark",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "custom-control-input",
                    "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
                  }, null, 40, _hoisted_12), [
                    [_vModelCheckbox, item.checked]
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frm.filter, (data, filterIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: filterIndex }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.items, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: itemIndex }, [
              (item.checked)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "badge bg-accent m-1 d-flex flex-row align-items-center filter-badge",
                    onClick: ($event: any) => (_ctx.uncheck(item))
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(data.name), 1),
                    _createElementVNode("b", _hoisted_17, _toDisplayString(item.name), 1),
                    _hoisted_18
                  ], 8, _hoisted_15))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
}